import React from 'react';
import '../../assets/css/websitemaintenance.scss';
const WebsiteMaintenance = () => {
  return (
    <main className="wrap">
      <h1>WEBSITE MAINTENANCE</h1>
      <p>
        We're doing some maintenance. Thanks for your patience — our site is
        temporarily unavailable while we tune things up.
      </p>
      <div className="illustration">
        <svg
          viewBox="0 0 800 500"
          fill="none"
          stroke="#111"
          strokeWidth={10}
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          {/* Laptop */}
          <rect
            x={150}
            y={180}
            width={500}
            height={260}
            rx={16}
            fill="#ffe594"
          />
          <rect x={170} y={200} width={460} height={180} rx={8} />
          <path d="M150 440h500l-50 40H200l-50-40z" fill="#ffe594" />
          {/* Gear icon */}
          <circle cx={620} cy={160} r={40} fill="#ffe594" />
          <path d="M620 120v-20M620 200v20M660 160h20M580 160h-20M645 135l14-14M595 185l-14 14M645 185l14 14M595 135l-14-14" />
          <circle cx={620} cy={160} r={14} />
          {/* Progress bar */}
          <rect x={170} y={320} width={460} height={30} rx={6} fill="#ffe594" />
          <rect x={170} y={320} width={230} height={30} rx={6} fill="#ffcd4d" />
        </svg>
      </div>
    </main>
  );
};

export default WebsiteMaintenance;
